const WIDTH_MD = 768;
const MOBILE_CHAT_ICON_SIZE_PX = 20;
const DESKTOP_CHAT_ICON_SIZE_PX = 30;
const LIVE_AGENT_MODE = 'live-agent';
const BOT_MODE = 'bot';
const CLOSED_MODE = 'closed';
const LIVE_AGENT_CALLBACK = 'speakWithLiveAgent';
const CHAT_BUTTON_Z_INDEX = 10000;
const AI_CHAT_STATE_KEY = 'ai-chat-state';

function updateChatUiWindowSizeChanged() {
  const chatState = window.sessionStorage.getItem(AI_CHAT_STATE_KEY);
  const isLiveAgentMode = chatState === LIVE_AGENT_MODE;

  document.getElementsByTagName('lux-chat-window')[0]?.setAttribute('chat-button-callback', isLiveAgentMode ? LIVE_AGENT_CALLBACK : '');

  const isMobile = document.documentElement.clientWidth <= WIDTH_MD;

  const luxChatWindow = document.getElementsByTagName('lux-chat-window')[0];

  if(!luxChatWindow) return;

  const luxChatContainer = luxChatWindow.shadowRoot?.querySelector('.chat');
  if (luxChatContainer){
    const isChatOpen = !luxChatContainer.classList.contains('hidden');
    if (document.scrollingElement instanceof HTMLHtmlElement) {
      document.scrollingElement.style.overflow = isChatOpen && !isLiveAgentMode && isMobile ? 'hidden': 'inherit';
    }
  }
}

function setAiChatWindowOpenState(isOpen) {
  const luxChatWindow = document.getElementsByTagName('lux-chat-window')[0];
  if(luxChatWindow){
    const luxChatContainer = luxChatWindow.shadowRoot?.querySelector('.chat');
    if (luxChatContainer){
      luxChatContainer.classList.toggle('hidden', !isOpen);
    }

    const chatButton = luxChatWindow.shadowRoot?.querySelector('lux-chat-open-button');
    if (chatButton) {
      const chatButtonInner = chatButton.shadowRoot?.querySelector('.open-chat-button');
      if (chatButtonInner) {
        chatButtonInner.classList.toggle('hidden', isOpen);
      }
    }
  }
}

function openLiveAgentChatWindow() {
  const five9Button = document.getElementById('five9-maximize-button');
  if (!five9Button) {
    console.warn('Five 9', 'Button does not exist, chat may have failed to load');
    return;
  }
  five9Button.click();
}

function updateChatUiOnLoad() {
  updateChatUiWindowSizeChanged();

  const chatState = window.sessionStorage.getItem(AI_CHAT_STATE_KEY);

  switch(chatState){
    case LIVE_AGENT_MODE:
      setAiChatWindowOpenState(false);
      openLiveAgentChatWindow();
      break;
    case BOT_MODE:
      setAiChatWindowOpenState(true);
      break;
    case CLOSED_MODE:
    default:
      setAiChatWindowOpenState(false);
      break;
  }
}

window.addEventListener('load', updateChatUiOnLoad);

// FUTURE: debounce resize handler
window.addEventListener('resize', updateChatUiWindowSizeChanged);

window.setChatState = function(chatState){
  if(!chatState){
    window.sessionStorage.removeItem(AI_CHAT_STATE_KEY);
  } else {
    window.sessionStorage.setItem(AI_CHAT_STATE_KEY, chatState);
  }
  document.getElementsByTagName('lux-chat-window')[0]?.setAttribute('chat-button-callback', chatState === LIVE_AGENT_MODE ? LIVE_AGENT_CALLBACK : '');
};

window.aiChatEventsHandler = {
  chatOpened: () => {
    window.setChatState(BOT_MODE);
  },
  chatClosed: () => {
    window.setChatState(CLOSED_MODE);
  },
};

window.speakWithLiveAgent = function() {
  console.log('Speak with live agent clicked');

  const isMobile = document.documentElement.clientWidth <= WIDTH_MD;
  if (!isMobile) {
    window.setChatState(LIVE_AGENT_MODE);
  }

  setAiChatWindowOpenState(false);

  openLiveAgentChatWindow();
};

const AI_CHAT_BUTTON_HTML = `<style>
  .hidden {
    display: none !important;
  }

  .open-chat-button {
    border: none;
    appearance: none;
    color: white;
    right: 0.7em;
    bottom: 0.7em;
    cursor: pointer;
    outline: none;
    padding: 1.4em;
    z-index: ${CHAT_BUTTON_Z_INDEX};
    position: fixed;
    font-size: 1em;
    border-radius: 50%;
    background-color: rgba(35, 35, 35, 0.85);
  }

  img.chatbot-avatar {
    width: ${DESKTOP_CHAT_ICON_SIZE_PX}px !important;
    height: ${DESKTOP_CHAT_ICON_SIZE_PX}px !important;
  }

  @media (max-width: ${WIDTH_MD}px) {
    .open-chat-button {
      right: 0.63em;
      bottom: 0.63em;
      padding: 1.26em;
    }

    img.chatbot-avatar {
      width: ${MOBILE_CHAT_ICON_SIZE_PX}px !important;
      height: ${MOBILE_CHAT_ICON_SIZE_PX}px !important;
    }
  }
</style>
<button
  class="open-chat-button"
>
  <img
    class="chatbot-avatar"
    src="https://cdn.shopify.com/s/files/1/0856/5977/9361/files/chat.svg?v=1757692398"
    alt="Chatbot Avatar"
    width="${DESKTOP_CHAT_ICON_SIZE_PX}"
    height="${DESKTOP_CHAT_ICON_SIZE_PX}"
  />
</button>`;

const AI_CHAT_SPEAK_WITH_AGENT_HTML = `
  <style>
    .live-agent-text {
    }

    .live-agent-link {
    }
  </style>
  <p class='live-agent-text'>
    If you need to chat with a live agent,
    <a class='live-agent-link' href='#' onclick="window.speakWithLiveAgent()">
      click here.
    </a>
  </p>`;

class AIBotChatButtonComponent extends HTMLElement {
  static tagName = 'lux-chat-open-button';
  constructor() {
    super();
    this.attachShadow({
      mode: 'open',
    });
  }

  connectedCallback() {
    if (!this.shadowRoot) return;
    this.shadowRoot.innerHTML = AI_CHAT_BUTTON_HTML;
  }

  get openButton() {
    return this.shadowRoot?.querySelector('.open-chat-button');
  }
}

class AIBotChatSpeakWithAgentComponent extends HTMLElement {
  static tagName = 'lux-speak-with-representative';
  constructor() {
    super();
    this.attachShadow({
      mode: 'open',
    });
  }

  connectedCallback() {
    if (!this.shadowRoot) return;
    this.shadowRoot.innerHTML = AI_CHAT_SPEAK_WITH_AGENT_HTML;
  }
}

if (!customElements.get(AIBotChatButtonComponent.tagName)) {
  customElements.define(AIBotChatButtonComponent.tagName, AIBotChatButtonComponent);
}

if (!customElements.get(AIBotChatSpeakWithAgentComponent.tagName)) {
  customElements.define(AIBotChatSpeakWithAgentComponent.tagName, AIBotChatSpeakWithAgentComponent);
}